import { CellFormKeys } from "./types";
import PSelect from "components/PSelect";
import { NumericCell } from "components/FormField/NumericCell";
import { stripNull } from "helpers/coll";
import { CellType, CellValidationConfig, TextCellValidationStrategy } from "generated/graphql";
import { FormControl, InputLabel, MenuItem, TextField } from "@mui/material";
import { UseForm } from "helpers/FormHelpers";

const StrategyOptions = [
  {
    title: "SSN",
    value: TextCellValidationStrategy.Ssn,
  },
  {
    title: "Custom",
    value: TextCellValidationStrategy.Custom,
  },
  {
    title: "Numeric",
    value: TextCellValidationStrategy.Numeric,
  },
  {
    title: "None",
    value: TextCellValidationStrategy.None,
  },
];

interface CellValidationFormProps {
  useForm: UseForm<CellFormKeys>;
}

function CellValidationForm({ useForm }: CellValidationFormProps) {
  const formState = useForm.formStateHandle[0];
  const cellType = formState.values.type;
  const updateInContext = (key: keyof CellValidationConfig, value: any) => {
    const config = Object.assign({}, formState.values.validationConfig);
    config[key] = value;
    if (key === "strategy" && value !== TextCellValidationStrategy.Custom) {
      config["regex"] = undefined;
    }
    useForm.updateField("validationConfig")(config);
  };

  return (
    <div className="flex flex-wrap gap-2">
      <div className="w-40">
        <NumericCell
          integerOnly={false}
          optional={true}
          value={stripNull(formState.values.validationConfig?.minValue)}
          setValue={(v) => updateInContext("minValue", v)}
          label={cellType === CellType.Text ? "Minimum Length" : "Minimum Value"}
        />
      </div>
      <div className="w-40">
        <NumericCell
          integerOnly={false}
          optional={true}
          value={stripNull(formState.values.validationConfig?.maxValue)}
          setValue={(v) => updateInContext("maxValue", v)}
          label={cellType === CellType.Text ? "Maximum Length" : "Maximum Value"}
        />
      </div>
      {cellType === CellType.Text && (
        <>
          <FormControl className="w-40">
            <InputLabel variant="outlined" style={{ backgroundColor: "white" }}>
              Text Matching Pattern
            </InputLabel>
            <PSelect
              label="Text Matching Pattern"
              id="strategy"
              value={formState.values.validationConfig?.strategy || TextCellValidationStrategy.None}
              onChange={(e) => {
                updateInContext("strategy", e.target.value);
              }}>
              {StrategyOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.title}
                </MenuItem>
              ))}
            </PSelect>
          </FormControl>
          {formState.values.validationConfig?.strategy === TextCellValidationStrategy.Custom && (
            <div className="w-40">
              <TextField
                label="Custom Regex"
                id="customRegex"
                placeholder="e.g., \d{4}(apple|banana)"
                value={formState.values.validationConfig?.regex}
                onChange={(e) => updateInContext("regex", e.target.value)}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default CellValidationForm;
